import { render, staticRenderFns } from "./addOrEdit2.vue?vue&type=template&id=09e48f7e&scoped=true"
import script from "./addOrEdit2.vue?vue&type=script&lang=js"
export * from "./addOrEdit2.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit2.vue?vue&type=style&index=0&id=09e48f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e48f7e",
  null
  
)

export default component.exports